import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import $ from "jquery";
import uniq from "lodash/uniq";
import Config from "../../config";

import {
  toggleSelectionFeatureInfo,
  setActiveFeature,
  toggleShowDescriptionCover, toggleShowRestorePopup, updateCanvasCount
} from "../../actions/actionFunctions";

import {getEventPosition, getFeatureIsLocked} from "../../misc/helpers";
// import {s3FeatureImagePath, THUMBNAIL_SIZES} from "../../misc/utils";

import ActionTypes from "../../misc/actionTypes";
import NavigationItemsList from "../visComponents/navigation/navigationItemsList";
import CountertopSwitchers from "../kvComponent/navigation/countertopSwitchers";
import CabinetSwitchers from "../kvComponent/navigation/cabinetSwitchers";
import {CABINET_GROUP, COUNTERTOP_GROUP} from "../kvComponent/core/constants";
import {UserPopupTypes} from "../visComponents/constants";
import {toggleNavItemPositionModal, toggleUpdateDisableFeatureGroupRadio} from "../../actions/navigationFunctions";
import {CABINET_GROUP_BATHROOM, COUNTERTOP_GROUP_BATHROOM} from "../bvSceneComponent/core/constants";
import SelectionMainVirtualizedList from "./selectionRowList/selectionMainVirtualizedList";
import LoadingSpinner from "../ui/loadingSpinner";
import WizardList from "./wizardList/wizardList";
import SelectionMainVirtualizedGrid from "./selectionGridList/selectionMainVirtualizedGrid";
import SelectionMainVirtualizedGridMobile from "./selectionGridList/selectionMainVirtualizedGridMobile";
import {wizardGroupInterface} from "../../interfaces/wizardItemInterface";
import {checkIfNeedToReceiveFeaturesIfFiltersApplied} from "../../misc/filtersFunctions";
import {getCurrentLayout} from "../appLayout";
import {clickOnSimilarFeatures, getApplyToLogic} from "../look/lookNavigation/lookNavigationFunctions";
import {navFeatureCLick} from "../look/lookNavigation/lookFunctions";
import {featureCanChangeShowerSize, searchForSameNameWallsBeforeFeatureApply} from "../look/bathroomFunctions";

class SelectionMainList extends NavigationItemsList {

  static propTypes = {
    features: PropTypes.array.isRequired,
    handleUserLoginClick: PropTypes.func.isRequired,
    setRef: PropTypes.func.isRequired,
    currentParent: PropTypes.object,
    listItemHeight: PropTypes.number,
    showItemsList: PropTypes.bool.isRequired,
    layoutName: PropTypes.string,
    isWizard: PropTypes.bool,
    currentGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface))
  };

  constructor(props) {
    super(props);
    this.state = {
      showPlaceHolders: document.bvConfig ? document.bvConfig.showPlaceholders : false,
      reorderedFeatures: [],
      showLoader: false,
      currentParentText: ""
    };
    window.itemClickCountQuote = window.itemClickCountQuote || 0;
    window.itemClickCount = window.itemClickCount || 0;
  }

  componentDidMount() {
    this.updatePositions(this.props);
    $(document).on(ActionTypes.USER_IS_LOGGED_IN, () => { // click on current active item after unlock
      if (this.props.currentParent && (this.props.currentParent.activeLockedFeature || this.props.currentParent.activeFeature)) {
        this.handleFeatureClick({
          part: this.props.currentParent.activeLockedFeature || this.props.currentParent.activeFeature
        });
      }
      this.forceUpdate(() => {
        if (!this.props.listItemHeight || this.props.listItemHeight < 10) { // $(".bv-item-list").height()
          $(window).trigger('resize'); // squeeze features bug
        }
      });
    });
    // console.log("|this.props.currentParent", this.props.currentParent);
    if (this.props.currentParent && this.props.currentParent.activeFeature) {
      this.props.setActiveFeature(this.props.currentParent.activeFeature);
      this.deleteNotInVisualizerFeature(this.props);
    }
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.USER_IS_LOGGED_IN);
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.currentParent && this.props.currentParent && (nextProps.currentParent.partName !== this.props.currentParent.partName))
      || (nextProps.currentParent && (nextProps.currentParent.partName !== this.state.currentParentText)) || nextProps.features !== this.props.features) {
      this.updatePositions(nextProps);
      this.deleteNotInVisualizerFeature(nextProps);
    }
    if (this.needToUpdate && nextProps.features.length !== this.props.features.length) {
      this.updatePositions(nextProps);
    }

    let wizardSubStepIsActive = false;
    if (nextProps.wizardConfig.length) {
      const existingWizSetup = nextProps.wizardConfig.find(wizObject => {
        return wizObject.featureGroupName === nextProps.currentParent.dbName || wizObject.featureGroupName === nextProps.currentParent.partName
      })
      if (existingWizSetup && existingWizSetup.filterGroups.length) {
        wizardSubStepIsActive = true;
      }
    }

    if (nextProps.selectedFilters.length && !wizardSubStepIsActive && nextProps.currentParent) {
      const checkPassed = checkIfNeedToReceiveFeaturesIfFiltersApplied(nextProps.selectedFilters, nextProps.currentParent);
      if (checkPassed) {
        this.getFeaturesFromBackendWithFilters(nextProps.currentParent, checkPassed.arrayOfNeededFiltersToReceive, 1);
      }
    }
  }

  deleteNotInVisualizerFeature = (nextProps) => {
    if (nextProps.currentParent && nextProps.currentParent.activeNotInVisualizerFeature
      && nextProps.currentParent.activeFeature && !nextProps.currentParent.activeFeature.notAvailableInVisualizer) {
      nextProps.currentParent.activeNotInVisualizerFeature = null;
    }
  }

  updatePositions = (nextProps) => {
    this.setState({
      indexesToReplace: [],
      showLoader: true
    }, () => {
      this.setRelatedStones(nextProps);
    });
  };

  checkForDisabled = (navItem) => {
    if (!navItem || !navItem.part || !navItem.part.getParent) {
      return
    }
    const parent = navItem.part.getParent();
    if (parent.disabled) {
      const itemParent = navItem.part.getParent();
      let exLAndBathtubAndSmallRoom = false;
      if (itemParent.partId === "left_shower_wall" && itemParent.getParent().layout.type === 0) {
        const showerBody = itemParent.getParent().layout.parts.Shower.showerBody;
        if (showerBody && showerBody.disabled) {
          exLAndBathtubAndSmallRoom = true
        }
      }
      if (itemParent.disabled && !exLAndBathtubAndSmallRoom) {
        itemParent.disabled = false;
        itemParent.disabledClick(); // disable also related parts
      }
    }
    if (parent.getParent) { // enable shower if child is clicked
      const showerParent = parent.getParent();
      if (showerParent.partName === "Shower" && showerParent.showerBody && showerParent.showerBody.disabled) {
        showerParent.showerBody.disabled = false;
        showerParent.showerBody.disabledClick(); // enable also related parts
      }
    }
  }

  handleFeatureClick = async (activeFeature, event, wizardClickOnLogic = null) => {

    if (event && (event.target.closest(".feature-buttons") || event.target.closest(".feature-toolSettings"))) {
      return false; // do not set activeFeature again ! // prevent redundant feature click
    } else if (this.props.activeFeature && this.props.activeFeature.dbFeature.id === activeFeature.part.dbFeature.id
      && (this.props.currentParent && this.props.currentParent.firstClick[this.props.activeQuoteIndex])) {
      this.showPositionsPopup(activeFeature.part, event);
      if (this.props.handleFeatureClick) {
        this.props.handleFeatureClick(activeFeature.part)
      }
      return false; // the same feature clicked // prevent redundant feature click
    }

    if (Config.isDevMode()) {
      console.log("activeFeature", activeFeature.part);
      console.log("sharedFeatureName:", activeFeature.part.dbFeature.sharedFeatureName, "\ngetSplittedFeatureName:", activeFeature.part.getSplittedFeatureName());
    }
    const fabricatorSettings = this.props.fabricatorData.settings;
    if(!this.props.userIsLoggedIn && fabricatorSettings.clickLeadCaptureOnQuote && fabricatorSettings.clickLeadCountOnQuote
      && (++window.itemClickCountQuote >= fabricatorSettings.clickLeadCountOnQuote)) {
      this.props.handleUserLoginClick(UserPopupTypes.NewDesign);
      return;
    }
    if (this.props.handleFeatureClick && !wizardClickOnLogic) {
      this.props.handleFeatureClick(activeFeature.part) // set wizard selected value
    }
    if (this.props.showRestorePopup) {
      this.props.toggleShowRestorePopup(false);
    }
    // if (this.isWallItem(activeFeature.part) && activeFeature.part.getParent().getParent().allWallsApplied) {
    //   this.applyAllWalls(activeFeature.part, ignoreLocked);
    // }

    if (!wizardClickOnLogic) {
      this.props.setActiveFeature(activeFeature.part); // set selected feature
    }

    const showPositionPopup = this.showPositionsPopup(activeFeature.part, event);
    if (showPositionPopup && !wizardClickOnLogic) {
      return // don't click on feature!! we are clicking inside the modal window
    }

    const layout = getCurrentLayout();

    if ((layout.isNewLayout || (layout.visualizerType === "bvScene")) && featureCanChangeShowerSize(activeFeature.part)) {
      await searchForSameNameWallsBeforeFeatureApply(activeFeature.part);
    }

    if (layout.isNewLayout) {

      navFeatureCLick(activeFeature.part);

      const applyToLogic = getApplyToLogic(activeFeature.part);
      // const parent = zoomFeature.getParent();
      // setActiveFeaturesBeforeAllWalls([], parent);  // we don't need it here, as we have remembering logic below
      if (applyToLogic && Array.isArray(applyToLogic.currentApplyToArray) && applyToLogic.currentApplyToArray.length) {
        clickOnSimilarFeatures(activeFeature.part, applyToLogic, true);
      }
    } else {

      activeFeature.part.handleClick(false, "", wizardClickOnLogic ? {skipNotCompatible: true} : null);

      if (CABINET_GROUP.includes(activeFeature.part.partId) || CABINET_GROUP_BATHROOM.includes(activeFeature.part.partId)) {
        const featureIsLocked = getFeatureIsLocked(activeFeature.part);
        CabinetSwitchers.applyAllCabinets(activeFeature.part, !featureIsLocked);
      } else if (COUNTERTOP_GROUP.includes(activeFeature.part.partId) || COUNTERTOP_GROUP_BATHROOM.includes(activeFeature.part.partId)) {
        const featureIsLocked = getFeatureIsLocked(activeFeature.part);
        CountertopSwitchers.applyAllCountertops(activeFeature.part, !featureIsLocked);
      }
    }

    this.checkForDisabled(activeFeature);
    // this.props.toggleShowDescriptionCover(false);
    // console.log('is visible', $('.feature--selected').is(':visible'));

    if (activeFeature.part.partId === "room") {
      this.props.checkIfNeedToSwitchRoom(activeFeature.part);
    }

    this.props.toggleUpdateDisableFeatureGroupRadio(true);
    $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
    this.props.updateCanvasCount();
    setTimeout(() => {
      this.props.toggleUpdateDisableFeatureGroupRadio(false);
    }, 0)

  };

  showPositionsPopup = (clickedFeature, event) => {
    if (clickedFeature && !clickedFeature.notAvailableInVisualizer
      && this.props.currentParent
      && this.props.currentParent.showLayerPositionsModal
      && this.props.currentParent.showLayerPositionsModal(clickedFeature)) {
      const eventPosition = getEventPosition(event);
      this.props.toggleNavItemPositionModal({
        popupOpened: true,
        popupPosition: {
          left: eventPosition.x,
          top: eventPosition.y
        },
        activePartId: clickedFeature.partId,
      });
      $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS); // update buttons
      return true
    } else if (this.props.navItemPositionModal && this.props.navItemPositionModal.popupOpened) {
      this.props.toggleNavItemPositionModal({
        popupOpened: false,
      });
    }
    return false
  }

  // isWallItem = (itemPart) => {
  //   const wallsPartIds = ["wall_a", "wall_b", "wall_c", "right_shower_wall", "left_shower_wall","pony_wall"];
  //   return wallsPartIds.includes(itemPart.partId);
  // };

  setRelatedStones(nextProps) {

    const selectedFirstItemIndex = this.getActiveItemIndex(nextProps);
    const features = nextProps.features.filter(feature => feature);
    let otherSelectedWallsIndexes = this.getSelectedWallIndexes(
      {part: nextProps.currentParent}, features, selectedFirstItemIndex
    );
    let unlockedIndexes = [];

    // console.log("otherSelectedWallsIndexes", otherSelectedWallsIndexes);

    const fabricatorSettings = this.props.fabricatorData.settings;  // set unlocked on the first positions
    if (nextProps.features.length && (fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !nextProps.isPhoneNumberValidated) {
      nextProps.features.forEach((feature, index) => {
        if (feature && feature.part && !getFeatureIsLocked(feature.part, false)) {
          unlockedIndexes.push(index);
        }
      });
    }

    const selectedExist = (selectedFirstItemIndex || selectedFirstItemIndex === 0) && selectedFirstItemIndex > -1;
    const indexesToReplace = selectedExist
      ? uniq([selectedFirstItemIndex, ...unlockedIndexes, ...otherSelectedWallsIndexes])
      : [...unlockedIndexes, ...otherSelectedWallsIndexes];
    this.setState({
      currentParentText: nextProps.currentParent ? nextProps.currentParent.partName : "",
      reorderedFeatures: this.getReorderedItems(indexesToReplace, nextProps, selectedExist, true),
      showLoader: false
    }, () => {
      if (this.needToUpdate) {
        const $gridBody = $(this.itemsList).find(".ReactVirtualized__Grid");
        if (this.props.windowWidth <= 991) {
          $gridBody.scrollLeft(this.needToUpdate);
        } else {
          $gridBody.scrollTop(this.needToUpdate);
        }
        this.needToUpdate = false;
      }
    });
  }

  getActiveItemIndex = (props) => {
    if (props.currentParent && props.currentParent.partId === "room") {
      return 0
    }
    const fabricatorSettings = props.fabricatorData.settings;
    const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;
    let isActiveItemIndex = null;
    if ((fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote))
      && !props.isPhoneNumberValidated && props.currentParent && props.currentParent.activeLockedFeature) {

      isActiveItemIndex = props.features.findIndex((item) => {
        return props.currentParent.activeLockedFeature.dbFeature.id === item.part.dbFeature.id
      });
      // console.log('props.currentParent', props.currentParent);
    } else if (props.currentParent && props.cartItemEditFeature) {
      isActiveItemIndex = props.features.findIndex((item) => {
        return item && item.part && (props.cartItemEditFeature.cartFeature.dbFeature.id === item.part.dbFeature.id)
      })
    } else if (props.currentParent && props.currentParent.activeNotInVisualizerFeature) {
      isActiveItemIndex = props.features.findIndex((item) => {
        return item && item.part && (props.currentParent.activeNotInVisualizerFeature.dbFeature.id === item.part.dbFeature.id)
      })
    } else if (props.currentParent && props.currentParent.activeFeature) {
      isActiveItemIndex = props.features.findIndex((item) => {
        return item && item.part && (props.currentParent.activeFeatureId(showPlaceHolders) === item.part.dbFeature.id)
      })
    }
    return isActiveItemIndex
  };

  checkIfFeatureSelected = (currentFeature, currentParent = this.props.currentParent) => {
    if (!currentFeature) {
      return false
    }

    const currentFeatureId = currentFeature.dbFeature.id;

    if (this.props.isWizard) {
      const {wizardSelectedValues, wizardActiveStep} = this.props;
      if (!wizardSelectedValues || !wizardSelectedValues[wizardActiveStep] || !wizardSelectedValues[wizardActiveStep].selectedFeature) {
        return false
      }
      if (currentFeature.dbFeature.sharedFeatureName && wizardSelectedValues[wizardActiveStep].selectedFeature.dbFeature.sharedFeatureName) {
        return currentFeature.dbFeature.sharedFeatureName === wizardSelectedValues[wizardActiveStep].selectedFeature.dbFeature.sharedFeatureName
      }
      return currentFeatureId === wizardSelectedValues[wizardActiveStep].selectedFeature.dbFeature.id
    }

    let selected = false;
    if (currentFeatureId && currentParent
      && ((this.props.activeFeature && !this.props.activeFeature.notAvailableInVisualizer) || currentParent.firstClick[this.props.activeQuoteIndex])) {
      selected = currentParent.activeNotInVisualizerFeature
        ? currentParent.activeNotInVisualizerFeature.dbFeature.id === currentFeatureId
        : this.props.activeFeature && this.props.activeFeature.dbFeature.id === currentFeatureId
    }
    return selected
  };

  handleOnMobileGridScroll = ({clientWidth, scrollLeft, scrollWidth}) => {
    if (this.props.showItemsList && !this.state.showLoader) {
      const ceilScrollWidth = Math.ceil(scrollWidth);
      const floorScrollWidth = Math.floor(scrollWidth);
      const ceilScrollLeft = Math.ceil(scrollLeft);
      const floorScrollLeft = Math.floor(scrollLeft);
      if ((ceilScrollWidth - ceilScrollLeft === clientWidth)
        || (ceilScrollWidth - floorScrollLeft === clientWidth)
        || (floorScrollWidth - ceilScrollLeft === clientWidth)
        || (floorScrollWidth - floorScrollLeft === clientWidth)) {
        this.getNewFeaturesOnScroll(scrollLeft, {part: this.props.currentParent})
      }
    }
  };

  // getLoadingElementsForGrid = (isMobile) => {
  //   const counts = getActivePartsCounts(this.props.currentParent, this.props.layoutName);
  //   if (!counts) {
  //     return null
  //   }
  //   let elements = [];
  //   let styles = isMobile ? {} : {
  //     height: this.props.listItemHeight
  //   };
  //   for (let i = 0; i <= counts ;i++ ) {  // for ex. 28/3 = 10 columns
  //     elements.push(
  //       <div className="feature" style={styles} key={i}>
  //         <LoadingSpinner/>
  //       </div>
  //     );
  //   }
  //   return elements
  // };

  renderVirtualizedGrid = () => {
    const {windowWidth, currentParent, listItemHeight, handleUserLoginClick, isWizard, currentGroups,
      showListForce} = this.props;
    // console.log("renderDesktopVirtualizedGrid currentFeatures", currentFeatures);
    if ((!showListForce && (currentParent && !currentParent.allFeaturesReceived)) || !this.itemsList) {
      return <LoadingSpinner/>
    }
    const currentFeatures = this.state.reorderedFeatures.filter(currentFeature => currentFeature);
    return (windowWidth || window.innerWidth) < 991 ? (
      <SelectionMainVirtualizedGridMobile currentFeatures={currentFeatures}
                                          isWizard={isWizard}
                                          currentGroups={currentGroups}
                                          scrollElement={this.itemsList}
                                          checkIfFeatureSelected={this.checkIfFeatureSelected}
                                          handleFeatureClick={this.handleFeatureClick}
                                          handleUserLoginClick={handleUserLoginClick}
                                          onScroll={this.handleOnMobileGridScroll}
                                          listItemHeight={listItemHeight}
                                          currentParent={currentParent}/>
    ) : (
      <SelectionMainVirtualizedGrid currentFeatures={currentFeatures}
                                    isWizard={isWizard}
                                    currentGroups={currentGroups}
                                    scrollElement={this.itemsList}
                                    checkIfFeatureSelected={this.checkIfFeatureSelected}
                                    handleFeatureClick={this.handleFeatureClick}
                                    handleUserLoginClick={handleUserLoginClick}
                                    onScroll={this.handleOnDesktopGridScroll}
                                    listItemHeight={listItemHeight}
                                    currentParent={currentParent}/>
    )
  }

  handleOnDesktopGridScroll = ({clientHeight, scrollHeight, scrollTop}) => {
    if (!clientHeight && !scrollHeight && !scrollTop) { // 0 0 0 check
      return
    }
    if (this.props.groheFiltersSearchText) {
      return
    }
    if (this.props.showItemsList && !this.state.showLoader) {
      const ceilScrollHeight = Math.ceil(scrollHeight);
      const floorScrollHeight = Math.floor(scrollHeight);
      const ceilScrollTop = Math.ceil(scrollTop);
      const floorScrollTop = Math.floor(scrollTop);
      if ((ceilScrollHeight - ceilScrollTop === clientHeight)
        || (ceilScrollHeight - floorScrollTop === clientHeight)
        || (floorScrollHeight - ceilScrollTop === clientHeight)
        || (floorScrollHeight - floorScrollTop === clientHeight)) {
        this.getNewFeaturesOnScroll(scrollTop, {part: this.props.currentParent})
      }
    }
  };

  renderVirtualizedList = () => {
    const {currentParent, isWizard, currentGroups, showListForce} = this.props;
    if ((!showListForce && (currentParent && !currentParent.allFeaturesReceived)) || !this.itemsList) {
      return <LoadingSpinner/>
    }
    return <SelectionMainVirtualizedList currentFeatures={this.state.reorderedFeatures}
                                         isWizard={isWizard}
                                         currentGroups={currentGroups}
                                         checkIfFeatureSelected={this.checkIfFeatureSelected}
                                         handleFeatureClick={this.handleFeatureClick}
                                         onScroll={this.handleOnDesktopGridScroll}
                                         currentParent={currentParent}/>
  }

  renderList = (isRowView) => {

    const {wizardConfig, currentParent, showListForce} = this.props;

    if (wizardConfig.length) {
      const existingWizSetup = wizardConfig.find(wizObject => {
        return wizObject.featureGroupName === currentParent.dbName || wizObject.featureGroupName === currentParent.partName
      })
      if (existingWizSetup && existingWizSetup.filterGroups.length && !existingWizSetup.isFinished && existingWizSetup.enableForQuoting) {
        if ((!showListForce && (currentParent && !currentParent.allFeaturesReceived)) || !this.itemsList) {
          return <LoadingSpinner/>
        }
        return <WizardList currentParent={currentParent}
                           listItemHeight={this.props.listItemHeight}/>
      }
    }

    return isRowView
      ? this.renderVirtualizedList()
      : this.renderVirtualizedGrid()
  }

  render() {
    const {selectionWindowView} = this.props;
    const isRowView = selectionWindowView === 4;
    return (
      <Fragment>
        <div ref={(node) => {
          this.itemsList = node;
          this.props.setRef(node);
        }}
             className={"bv-item-list bv-item-list--" + this.props.selectionWindowView
             + (this.props.filtersVisible ? " bv-item-list--filters-visible" : "")
             + (isRowView ? " bv-item-list--row" : " bv-item-list--column")}>
          {this.props.showItemsList && !this.state.showLoader
            ? this.renderList(isRowView)
            : <LoadingSpinner/>
          }
        </div>
        {/*{this.state.additionalFeaturesLoading || this.props.navigationLoadingActive ? this.getLoadingFeatures() : null}*/}
        {this.state.additionalFeaturesLoading ? this.getLoadingFeatures() : null}
      </Fragment>
    )
  }
}

const mapStateToProps = (store) => {

  const {wizardConfig, wizardSelectedValues, wizardActiveStep} = store.wizardState;
  // const {navigationLoadingActive} = store.navigationState;
  const {cartItemEditFeature} = store.cartState;
  const {groheFiltersSearchText} = store.groheState;

  return {
    selectionWindowView: store.selectionState.selectionWindowView,
    navigationViewType: store.selectionState.selectionWindowView, // needed for NavigationItemsList
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    windowWidth: store.serverState.windowWidth,
    activeFeature: store.selectionState.activeFeature,
    filtersVisible: store.filterState.showFilters,
    fabricatorData: store.fabricatorState,
    userPopupOpened: store.userState.userPopupOpened,
    filterGroups: store.filterState.filterGroups,
    showRestorePopup: store.bathroomVisualizerState.showRestorePopup,
    selectedFilters: store.filterState.selectedFilters,
    userIsLoggedIn: store.userState.userIsLoggedIn,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    navItemPositionModal: store.navigationState.navItemPositionModal,
    wizardConfig,
    wizardSelectedValues,
    wizardActiveStep,
    cartItemEditFeature,
    groheFiltersSearchText,
    // navigationLoadingActive,
  };
};

export default connect(mapStateToProps, {
  toggleSelectionFeatureInfo,
  setActiveFeature,
  toggleShowDescriptionCover,
  toggleShowRestorePopup,
  toggleUpdateDisableFeatureGroupRadio,
  toggleNavItemPositionModal,
  updateCanvasCount,
})(SelectionMainList);
